import UniformProductCard from "./src/product-card";
export type { UniformProduct } from "./src/product-card";

export default UniformProductCard;
